export const menus = [
	{
		title: 'Báo cáo',
		icon: 'line-chart',
		permission: ['ROLE_ADMIN'],
		children: [
			{
				path: '/revenue',
				title: 'Hoạt động kinh doanh',
				permission: ['ROLE_ADMIN']
			},
			{
				path: '/inventory-report',
				title: 'Báo cáo tồn kho',
				permission: ['ROLE_ADMIN']
			},
			// {
			// 	path: '/customer-refund',
			// 	title: 'Khách trả hàng',
			// 	permission: ['ROLE_ADMIN']
			// }
		]
	},
	{
		title: 'Đơn hàng',
		icon: 'container',
		// permission: ['ROLE_ADMIN', 'ROLE_SALES'],
		children: [
			{
				path: '/create-orders',
				title: 'Tạo đơn',
				permission: ['ROLE_ADMIN', 'ROLE_SALES']
			},
			{
				path: '/orders',
				title: 'Danh sách đơn hàng',
				permission: ['ROLE_ADMIN', 'ROLE_SALES', 'ROLE_TECHNIQUE'],
				createChildrenMenu: false,
				children: [
					{
						path: '/orders/:id',
						title: 'Chi tiết đơn hàng',
						permission: ['ROLE_ADMIN', 'ROLE_SALES']
					}
				]
			},
			{
				path: '/customer-refund',
				title: 'Khách trả hàng',
				permission: ['ROLE_ADMIN', 'ROLE_SALES'],
				createChildrenMenu: false,
				children: [
					{
						path: '/customer-refund/create',
						title: 'Tạo đơn hoàn trả',
						permission: ['ROLE_ADMIN', 'ROLE_SALES'],
					},
					{
						path: '/customer-refund/:id',
						title: 'Chi tiết đơn hoàn trả',
						permission: ['ROLE_ADMIN', 'ROLE_SALES'],
					}
				]
			}
		]
	},
	{
		title: 'Sản phẩm',
		icon: 'inbox',
		permission: ['ROLE_ADMIN', 'ROLE_SALES'],
		children: [
			{
				path: '/product',
				title: 'Danh sách sản phẩm',
				permission: ['ROLE_ADMIN', 'ROLE_SALES'],
				createChildrenMenu: false,
				children: [
					{
						path: '/product/create',
						title: 'Thêm mới sản phẩm',
						permission: ['ROLE_ADMIN', 'ROLE_SALES'],
					},
					{
						path: '/product/:id',
						title: 'Chi tiết sản phẩm',
						permission: ['ROLE_ADMIN', 'ROLE_SALES'],
					},
					{
						path: '/product/edit/:id',
						title: 'Cập nhật sản phẩm',
						permission: ['ROLE_ADMIN', 'ROLE_SALES'],
					}
				]
			},
			{
				path: '/purchase-order',
				title: 'Nhập hàng',
				permission: ['ROLE_ADMIN', 'ROLE_SALES'],
				createChildrenMenu: false,
				children: [
					{
						path: '/purchase-order/create',
						title: 'Tạo đơn nhập hàng',
						permission: ['ROLE_ADMIN', 'ROLE_SALES'],
					},
					{
						path: '/purchase-order/:id',
						title: 'Chi tiết đơn nhập hàng',
						permission: ['ROLE_ADMIN', 'ROLE_SALES'],
					}
				]
			},
			{
				path: '/refund',
				title: 'Quản lý hoàn trả',
				permission: ['ROLE_ADMIN', 'ROLE_SALES'],
				createChildrenMenu: false,
				children: [
					{
						path: '/refund/create',
						title: 'Tạo đơn hoàn trả',
						permission: ['ROLE_ADMIN', 'ROLE_SALES'],
					},
					{
						path: '/refund/:id',
						title: 'Chi tiết đơn hoàn trả',
						permission: ['ROLE_ADMIN', 'ROLE_SALES'],
					},
					{
						path: '/refund/edit/:id',
						title: 'Cập nhật đơn hoàn trả',
						permission: ['ROLE_ADMIN', 'ROLE_SALES'],
					}
				]
			},
			{
				path: '/supplier',
				title: 'Nhà cung cấp',
				permission: ['ROLE_ADMIN', 'ROLE_SALES'],
				createChildrenMenu: false,
				children: [
					{
						path: '/supplier/create',
						title: 'Tạo nhà cung cấp',
						permission: ['ROLE_ADMIN', 'ROLE_SALES'],
					},
					{
						path: '/supplier/:id',
						title: 'Chi tiết nhà cung ấp',
						permission: ['ROLE_ADMIN', 'ROLE_SALES'],
					},
					{
						path: '/supplier/edit/:id',
						title: 'Cập nhật nhà cung cấp',
						permission: ['ROLE_ADMIN', 'ROLE_SALES'],
					}
				]
			}
		]
	},
	{
		title: 'Khách hàng',
		icon: 'user',
		permission: ['ROLE_ADMIN', 'ROLE_SALES'],
		children: [
			{
				path: '/customer',
				title: 'Danh sách khách hàng',
				permission: ['ROLE_ADMIN', 'ROLE_SALES'],
				createChildrenMenu: false,
				children: [
					{
						path: '/customer/create',
						title: 'Thêm mới khách hàng',
						permission: ['ROLE_ADMIN', 'ROLE_SALES'],
					},
					{
						path: '/customer/:id',
						title: 'Chi tiết khách hàng',
						permission: ['ROLE_ADMIN', 'ROLE_SALES'],
					},
					{
						path: '/customer/edit/:id',
						title: 'Cập nhật khách hàng',
						permission: ['ROLE_ADMIN', 'ROLE_SALES'],
					}
				]
			}
		]
	},
	{
		title: 'Bảo hành',
		icon: 'safety',
		permission: ['ROLE_ADMIN', 'ROLE_TECHNIQUE'],
		children: [
			{
				path: '/warranty-card',
				title: 'Phiếu bảo hành',
				permission: ['ROLE_ADMIN', 'ROLE_TECHNIQUE'],
				createChildrenMenu: false,
				children: []
			},
			// {
			// 	path: '/warranty-claim-card',
			// 	title: 'Yêu cầu bảo hành',
			// 	permission: ['ROLE_ADMIN', 'ROLE_TECHNIQUE'],
			// 	createChildrenMenu: false,
			// 	children: []
			// },
			// {
			// 	path: '/warranty-terms',
			// 	title: 'Chính sách bảo hành',
			// 	permission: ['ROLE_ADMIN', 'ROLE_TECHNIQUE'],
			// 	createChildrenMenu: false,
			// 	children: []
			// }
		]
	}
];
